import React from 'react';

export const HamburgerIcon = (props) => {
  const { theme } = props;

  return (
    <svg width="2.2rem" viewBox="0 0 25 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Group</title>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
        <g
          id="Home-(Hamburger-Menu)-Copy"
          transform="translate(-24.000000, -21.000000)"
          stroke={theme === 'light' ? '#4A5866' : '#B9B9C1'}
          strokeWidth="3.24"
        >
          <g id="Group" transform="translate(26.000000, 22.000000)">
            <line x1="0" y1="1" x2="21" y2="1" id="Line" />
            <line x1="0" y1="9" x2="21" y2="9" id="Line-Copy" />
            <line x1="0" y1="17" x2="21" y2="17" id="Line-Copy-2" />
          </g>
        </g>
      </g>
    </svg>
  );
};
